import React from 'react'
import { Button, Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import './CaseNavigationBar.scss'

const CaseNavigationBar = ({
  title,
  subtitle,
  rightButtonText,
  handleClickLeft,
  handleRightClick,
  shadow,
  isClosed,
  isDraft,
  isRightButtonDisabled,
  caseNumber,
  hideCloseButton,
  isInline,
}) => {
  const renderTitle = () => {
    if (caseNumber) {
      return (
        <h6 className="title">
          <Link to={`/cases/${caseNumber}`}>{title}</Link>
        </h6>
      )
    }
    return <h6 className="title">{title}</h6>
  }

  const renderSubtitle = () => {
    if (caseNumber) {
      return <Link to={`/cases/${caseNumber}`}>{subtitle}</Link>
    }
    return subtitle
  }

  return (
    <Navbar
      className={`navbar navbar-expand-md case-nav-bar ${shadow} ${
        hideCloseButton ? 'case-nav-bar-merged' : 'bg-white'
      } ${isInline === 'sticky' ? 'sticky-case-navigation-bar' : ''}`}
      fixed={hideCloseButton || isInline === 'sticky' || isInline === true ? undefined : 'top'}
    >
      <div className="container">
        {!hideCloseButton && (
          <Button variant="link" type="button" id="leftBtn" onClick={handleClickLeft}>
            <i className="fas fa-lg fa-times close-icon"></i>
          </Button>
        )}
        <div className="ml-auto mr-auto mt-2 mb-1">
          {renderTitle()}
          <div className="subtitle">
            {renderSubtitle()}
            {isClosed && (
              <span className="badge badge-danger ml-2" style={{ fontSize: '0.9em', verticalAlign: 'text-bottom' }}>
                CLOSED
              </span>
            )}
            {isDraft && !isClosed && (
              <span className="badge badge-warning ml-2" style={{ fontSize: '0.9em', verticalAlign: 'text-bottom' }}>
                DRAFT
              </span>
            )}
          </div>
        </div>
        <div className="save-button-container">
          <Button
            className="action-button"
            type="button"
            variant="link"
            id="rightBtn"
            onClick={handleRightClick}
            disabled={isRightButtonDisabled}
          >
            {rightButtonText}
          </Button>
        </div>
      </div>
    </Navbar>
  )
}

CaseNavigationBar.Container = ({ children }) => <div style={{ marginTop: '4.2rem' }}>{children}</div>

export default CaseNavigationBar
